var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStressIndex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 23,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98401 11.28L8.48001 12.672L6.38401 13.376L9.88001 15.472",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17603 4.98401L11.976 7.78401H9.17603L11.976 11.28",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.84 4.98401L28.048 7.78401H30.84L28.048 11.28",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.032 11.28L31.544 12.672L34.336 14.072L30.84 15.472",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.376 14.0721C13.376 14.0721 16.168 7.78406 20.368 8.48006C20.368 8.48006 25.256 9.17606 26.656 14.0721",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.472 21.7601C15.472 21.7601 16.168 19.6641 15.472 18.2641C15.472 17.5681 15.472 16.8641 16.168 15.4721C16.864 14.0801 15.472 12.6801 14.072 13.3761C13.376 14.0721 10.576 15.4721 11.976 19.6641",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9759 19.6641L6.38395 29.4481C6.38395 29.4481 4.28795 32.2401 6.38395 33.6401C7.07995 34.3361 9.87995 35.7361 11.2719 32.9441L15.4639 21.7601L11.9759 19.6641Z",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.64 28.0481C37.136 32.2401 33.64 34.3361 33.64 34.3361C29.448 37.1281 28.048 32.2401 28.048 32.2401L23.856 21.7601L28.744 19.6641L30.84 23.8561",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.096 21.392C25.096 21.392 23.856 19.664 24.552 18.272C24.552 16.872 24.552 16.176 23.856 14.776C23.856 14.776 23.856 11.984 26.648 14.08C28.048 15.48 29.44 16.176 28.744 19.672",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.168 14.768C16.168 14.768 17.568 13.368 18.96 13.368C19.656 14.064 22.032 16.096 24.344 16.48",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7681 23.16C14.7681 23.16 19.7441 28.416 24.5921 23.344",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.96 22.456C18.96 22.456 19.656 21.056 21.056 22.456",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.568 19.664L18.96 18.96",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.456 19.664L21.056 18.96",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.568 25.256C17.568 25.256 18 27.504 13.592 27.432",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4561 24.912C22.4561 24.912 23.0161 27.76 26.2321 27.552",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2321 26.8C16.2321 26.8 19.7601 30.8161 23.9041 26.9921",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.576 33.64L29.1201 34.032",
    stroke: "#192852",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2401 26.648C32.6245 26.648 32.9361 26.3364 32.9361 25.952C32.9361 25.5676 32.6245 25.256 32.2401 25.256C31.8557 25.256 31.5441 25.5676 31.5441 25.952C31.5441 26.3364 31.8557 26.648 32.2401 26.648Z",
    stroke: "#192852",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressIndex);
export default __webpack_public_path__ + "static/media/StressIndex.95a048f076cb34ae91472f6be6df1d3e.svg";
export { ForwardRef as ReactComponent };